(() => {
  // app/scripts/predictive-search.js
  var { debounce } = AT;
  window.customElements.define("predictive-search", class extends HTMLElement {
    constructor() {
      super();
      this.elms = {
        formContainer: this.querySelector("form"),
        inputElement: this.querySelector("input[name='q']"),
        resultsContanier: this.querySelector(".search-results"),
        buttonSubmit: this.querySelector("button[type='submit']")
      };
    }
    connectedCallback() {
      this.initInputEvent();
    }
    get getSearchQuery() {
      const formData = new FormData(this.elms.formContainer);
      const params = new URLSearchParams(formData);
      return params.toString() + "&section_id=" + this.dataset.section;
    }
    initInputEvent() {
      const { inputElement } = this.elms;
      this.addEvent("focusin", () => {
        this.addClass("active");
      });
      this.addEvent("focusout", () => {
        this.removeClass("active");
      });
      inputElement.addEvent("input", debounce(() => {
        let value = inputElement.value.trim();
        if (!value)
          return;
        this.createSearch();
      }, 500));
    }
    async createSearch() {
      let { buttonSubmit } = this.elms;
      if (!theme.settings.search.disable) {
        buttonSubmit.addClass("pending");
      }
      let result = await fetch(`${theme.routes.suggestUrl}?${this.getSearchQuery}`);
      result = await result.text();
      const div = document.createElement("div");
      div.innerHTML = result;
      this.querySelector(".search-results").innerHTML = div.querySelector(".shopify-section").innerHTML;
      let { resultsContanier } = this.elms;
      if (typeof Currencies !== "undefined") {
        resultsContanier.getElementsByClassName("js-money").forEach(Currencies.registerObserve.bind(Currencies));
      }
      if (!theme.settings.search.disable) {
        buttonSubmit.removeClass("pending");
      }
      if (resultsContanier.querySelector(".no-result")) {
        resultsContanier.removeClass("has-results");
        resultsContanier.addClass("no-results");
      } else {
        resultsContanier.removeClass("no-results");
        resultsContanier.addClass("has-results");
      }
    }
  });
})();
